import { owcTheme } from 'core/theme/theme.config';
import { PocButton } from 'commons/components/components-wrapper';
import styled from 'styled-components';

export const CopyButtonStyled = styled(PocButton)`
    min-height: 24px;

    button {
        padding: 4px 8px;
    }
`;

export const CopiedButtonStyled = styled(CopyButtonStyled)`
    color: ${owcTheme['one-color-foreground-positive-base']} !important;
`;
